import type Phaser from 'phaser';

/**
 * Dark vertical gradient with a sparse star field — the shared backdrop for
 * the meta screens (menu, level select, shop).
 */
export function drawStarfield(scene: Phaser.Scene, W: number, H: number): void {
  const g = scene.add.graphics();
  g.fillGradientStyle(0x12102a, 0x12102a, 0x05060f, 0x05060f, 1);
  g.fillRect(0, 0, W, H);
  for (let i = 0; i < 220; i++) {
    const x = Math.random() * W;
    const y = Math.random() * H;
    const r = Math.random() < 0.85 ? 1 : 2;
    g.fillStyle(0xffffff, 0.3 + Math.random() * 0.6);
    g.fillCircle(x, y, r);
  }
}
